import type { CityConfig } from "@/pages/city-template/types";

export const elmiraConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Elmira",
  state: "New York",
  stateAbbr: "NY",
  slug: "elmira",
  route: "/cities/elmira",
  title: "Emergency Passport Elmira, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Elmira, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Corning tech travelers, Finger Lakes tourism, and all Chemung County residents.",
  h1: "Emergency & Expedited Passport Services in Elmira, NY",
  heroSubtitle: "Corning Incorporated executive flying to Tokyo for a supplier meeting? Finger Lakes wine tour heading to European vineyards? Elmira College student studying abroad in Paris? We help Elmira residents — from Corning engineers to Horseheads families to Watkins Glen tourism workers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Elmira%20New%20York%20historic%20downtown%20with%20the%20Chemung%20River%20flowing%20through%20the%20city%2C%20historic%20brick%20architecture%20from%20the%20Mark%20Twain%20era%2C%20Southern%20Tier%20hills%20with%20autumn%20colors%20in%20the%20background%2C%20Corning%20corporate%20headquarters%20visible%20in%20the%20distance%2C%20warm%20golden%20hour%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20industrial%20heritage%20cityscape&width=1800&height=700&seq=elmira-hero-2026&orientation=landscape",
  heroImageAlt: "Elmira New York downtown with Chemung River and Southern Tier hills at golden hour",
  geoPosition: "42.0908; -76.8077",
  geoPlacename: "Elmira, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~210 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Elmira", zips: "14901, 14902, 14903, 14904, 14905, 14925" },
    { name: "Corning", zips: "14830, 14831" },
    { name: "Horseheads", zips: "14845, 14844" },
    { name: "Big Flats", zips: "14814" },
    { name: "Watkins Glen", zips: "14891" },
    { name: "Waverly", zips: "14892" },
    { name: "Sayre", zips: "18840" },
    { name: "Binghamton", zips: "13901, 13902, 13903, 13904, 13905, 13933, 13935, 13944, 13945" },
    { name: "Ithaca", zips: "14850, 14851, 14852, 14853" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Elmira-area travelers with immediate departures." },
    { icon: "ri-building-2-line", title: "Corning Inc. Corporate Travel Ready", desc: "Corning Incorporated executives, engineers, and researchers traveling to global facilities in Taiwan, Japan, Germany, and South Korea — we handle short-notice international business travel." },
    { icon: "ri-landscape-line", title: "Finger Lakes Tourism & Wine Industry", desc: "Finger Lakes wine professionals traveling to European wine regions, Watkins Glen tourism workers heading abroad, and seasonal visitors who discover passport issues before international trips." },
    { icon: "ri-graduation-cap-line", title: "College & University Expedited", desc: "Elmira College, Corning Community College, and Keuka College students studying abroad — we guide first-time applicants through the acceptance process." },
  ],
  internalLinks: [
    { name: "Fast passport services in Corning, NY", route: "/cities/corning" },
    { name: "Expedited passport in Ithaca, NY", route: "/cities/ithaca" },
    { name: "Quick passport services in Binghamton, NY", route: "/cities/binghamton" },
    { name: "Urgent passport services in Syracuse, NY", route: "/cities/syracuse" },
    { name: "New York passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Elmira via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the 210-mile drive to Manhattan. Elmira residents can ship from any UPS Store, FedEx Office, or post office location across Chemung County.",
  fpcOfficeDistance: "Serving Elmira, Corning, Horseheads, and all Chemung County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Elmira and the greater Twin Tiers region. From the historic downtown along the Chemung River to the Corning corporate headquarters on the Erie Avenue campus, from Horseheads to Watkins Glen — we serve all of Chemung County, Steuben County, and the Southern Tier. Our courier service eliminates the need to drive 210 miles to Manhattan.",
  nearbyCitiesIntro: "We serve Elmira and all Twin Tiers communities including Corning, Horseheads, Big Flats, Watkins Glen, and Waverly. We also serve travelers departing from Elmira Corning Regional Airport (ELM) and Greater Binghamton Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Elmira as simple as possible — with the efficiency and reliability Corning executives, Finger Lakes tourism professionals, and Twin Tiers families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Elmira travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Elmira travelers encounter unique passport issues — everything from Corning Inc. global business travel to 6-month validity rules for Asian semiconductor destinations to Finger Lakes wine industry European travel. Here are the most common mistakes.",
  testimonialsIntro: "Elmira travelers — from Corning engineers to Horseheads families to Watkins Glen winemakers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Elmira, NY? Here are the most common ones we hear from Twin Tiers travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a Corning Inc. trip to Japan, an emergency passport for a sudden overseas assignment, or a first-time passport for an Elmira College semester abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx and other resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Corning Inc. supplier meeting in Tokyo next week? Family emergency overseas? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Elmira-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Elmira residents renew fast — no agency visit required for most renewals. Perfect for Corning engineers and Finger Lakes wine professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Elmira residents through every step — from downtown Elmira to Corning to Horseheads — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your international business trip or Finger Lakes wine tour is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Corning Inc. executives and engineers who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Twin Tiers travelers through the process so your international business trip stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Elmira residents visiting Canada via the Thousand Islands or Niagara Falls.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Elmira NY", description: "Urgent passport processing for Elmira New York travelers with immediate departure needs including Corning Inc. business travel." },
    { name: "Expedited Passport Renewal Elmira NY", description: "Fast passport renewal for Elmira New York residents with a previously-issued passport." },
    { name: "First-Time Passport Elmira NY", description: "New passport application services for Elmira New York residents applying for their first passport." },
    { name: "Child Passport Elmira NY", description: "Minor passport services for Elmira New York families with children under 16." },
    { name: "Name Change Passport Elmira NY", description: "Passport name correction after marriage, divorce, or legal name changes for Elmira residents." },
    { name: "Second Passport Elmira NY", description: "Second passport services for Corning Inc. executives and frequent international travelers in Elmira." },
  ],
  testimonials: [
    {
      name: "James R.",
      location: "Corning, NY",
      rating: 5,
      text: "Corning needed me in Taiwan for a supplier audit with 8 days' notice. My passport was expired. Fast Passport Center got it renewed in 3 days. The document review caught an issue with my photo that would have caused a rejection.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Patricia M.",
      location: "Horseheads, NY",
      rating: 5,
      text: "We planned a Finger Lakes wine tour trip to Bordeaux and realized our passports expired 3 weeks before departure. Fast Passport Center handled both applications and got them back in 5 days.",
      service: "Passport Renewal",
    },
    {
      name: "Diane S.",
      location: "Elmira, NY",
      rating: 5,
      text: "First-time passport for my Elmira College daughter studying abroad in Paris. The agent walked us through the acceptance clerk process and everything was processed in 5 days. Incredibly smooth.",
      service: "New Passport",
    },
    {
      name: "Tom W.",
      location: "Watkins Glen, NY",
      rating: 5,
      text: "I work in wine tourism and needed a passport for a European wine conference. Fast Passport Center got my damaged passport replaced in 4 days. The Watson Homestead conference center recommended them.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "elmira-1",
      name: "Elmira Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 Madison Avenue",
      city: "Elmira",
      state: "NY",
      zip: "14901",
      phone: "(607) 732-6138",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Elmira",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Elmira passport acceptance facility. Passport photos available on-site. Appointment recommended. Busiest facility in Chemung County — book early during spring and fall travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "elmira-2",
      name: "Corning Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "139 Baker Street",
      city: "Corning",
      state: "NY",
      zip: "14830",
      phone: "(607) 962-2501",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Corning — ~10 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Corning Incorporated employees and Corning residents. Less crowded than Elmira Main — good alternative during peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "elmira-3",
      name: "Horseheads Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1016 Wyncoop Creek Road",
      city: "Horseheads",
      state: "NY",
      zip: "14845",
      phone: "(607) 739-8224",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Horseheads — ~5 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Horseheads, Big Flats, and north Elmira communities. Passport photos available on-site. Saturday appointments fill quickly during summer tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "elmira-4",
      name: "Watkins Glen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 North Franklin Street",
      city: "Watkins Glen",
      state: "NY",
      zip: "14891",
      phone: "(607) 535-2721",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Watkins Glen — ~20 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Watkins Glen and Schuyler County communities. Smaller facility — call ahead to confirm passport acceptance hours, especially during summer tourism peak.",
      icon: "ri-mail-line",
    },
    {
      id: "elmira-5",
      name: "Elmira College — Study Abroad Office",
      type: "Campus Passport Guidance",
      address: "One Park Place",
      city: "Elmira",
      state: "NY",
      zip: "14901",
      phone: "(607) 735-1800",
      hours: "Mon–Fri 8:00 AM – 4:00 PM (academic year)",
      distance: "Elmira College campus",
      website: "https://www.elmira.edu/",
      websiteLabel: "Elmira College",
      notes: "Study abroad office provides guidance for students needing first-time passports. Not a full passport acceptance facility — students directed to Elmira Post Office for the acceptance clerk visit.",
      icon: "ri-graduation-cap-line",
    },
    {
      id: "elmira-6",
      name: "Big Flats Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "465 Maple Street",
      city: "Big Flats",
      state: "NY",
      zip: "14814",
      phone: "(607) 562-8518",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Big Flats — ~10 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Big Flats and western Chemung County. Near the Elmira Corning Regional Airport — convenient for travelers combining acceptance visit with airport departure.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 210 miles to Manhattan's New York Passport Agency", fpc: "Most Twin Tiers travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Corning & Finger Lakes Expertise", agency: "Generic — no Corning Inc. business travel or Finger Lakes tourism knowledge", fpc: "Full Corning corporate, wine industry, and Finger Lakes tourism knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Corning Inc. Asia Travel Without 6-Month Validity",
      description: "Corning engineers traveling to Taiwan, Japan, South Korea, and China frequently do not know their passport must have 6 months remaining beyond the return date. We flag this immediately — a common Corning Inc. travel desk oversight.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Elmira applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Elmira pharmacies produce photos that fail State Department standards. We catch this in document review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for College Students",
      description: "Elmira College and Corning Community College students applying for first-time passports often overlook the DS-3053 consent form when a parent is unavailable. This is an automatic rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long — Standard Mail Takes 8–11 Weeks",
      description: "Finger Lakes wine tour operators and Corning engineers booking European travel months in advance assume there is plenty of time — then discover standard processing takes 8–11 weeks and their departure is 6 weeks away.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or Corning office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Elmira clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 210 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Elmira?", a: "We offer Elmira-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an Elmira office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Elmira Post Office, Corning Post Office, or Horseheads Post Office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Elmira address." },
    { q: "Where can I get a passport acceptance in Elmira?", a: "Elmira has passport acceptance at the Main Post Office on Madison Avenue, the Corning Post Office on Baker Street, the Horseheads Post Office, and the Watkins Glen Post Office. We maintain an updated list of facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 210 miles from Elmira) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without leaving the Twin Tiers." },
    { q: "What is the best price for expedited passport service in Elmira?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Elmira applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide an Elmira-specific checklist." },
    { q: "Can I get a passport photo in Elmira?", a: "Yes — CVS, Walgreens, UPS Store, and Walmart locations throughout Elmira, Corning, and Horseheads offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Elmira passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Elmira to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with Corning Inc. employee passport timing?", a: "Yes. We regularly assist Corning Incorporated employees with expedited passports for global supplier meetings, manufacturing site visits, and technology conferences in Asia and Europe. We understand the short-notice windows common in corporate technology travel." },
    { q: "Is Elmira near any international airports?", a: "Elmira Corning Regional Airport (ELM) offers domestic connections through Detroit and Philadelphia. For international departures, most Elmira travelers drive to Syracuse Hancock (SYR, 90 miles), Rochester (ROC, 90 miles), or Buffalo Niagara (BUF, 150 miles) for direct international flights." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Elmira Residents",
    intro: "Elmira's position as a Corning Inc. corporate hub and Finger Lakes gateway creates distinct passport timing challenges. Here's what Twin Tiers travelers need to know.",
    cards: [
      {
        icon: "ri-building-2-line",
        title: "Corning Incorporated — Global Technology Travel",
        subtitle: "Fortune 500 manufacturer with facilities in 34 countries",
        description: "Corning Incorporated is the economic engine of the Elmira-Corning region. With manufacturing sites and research facilities in Taiwan, Japan, South Korea, Germany, China, and across Europe and Asia, Corning engineers and executives travel internationally on short notice. Supplier audits, technology transfer meetings, and global manufacturing site visits typically come with 1–3 week booking-to-departure windows. The high volume of Asia travel means 6-month passport validity requirements are a constant issue — something Corning travel desks do not always flag.",
        tip: "If you work at Corning and travel to Asia, always self-check your passport validity. Many Asian countries require 6 months beyond your return date, and Corning travel desks are focused on flights and hotels, not passport expiration dates.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ELM — Elmira Corning Regional Airport",
        subtitle: "Delta Connection to Detroit, regional service",
        description: "Elmira Corning Regional Airport serves the Twin Tiers with Delta Connection flights to Detroit and seasonal service. While ELM is primarily a domestic airport, it connects Twin Tiers travelers to international gateways through DTW. The limited flight schedule means travelers must plan connecting itineraries carefully — a missed connection due to a passport issue at the international gateway can strand you for 24+ hours.",
        tip: "A domestic flight from ELM to Detroit does not require a passport, but your final destination in Asia or Europe does. Always verify passport validity when booking connecting international itineraries.",
      },
      {
        icon: "ri-goblet-line",
        title: "Finger Lakes Wine Industry International Travel",
        subtitle: "Wine professionals heading to Europe and South America",
        description: "The Finger Lakes wine region — including Watkins Glen, Seneca Lake, and Keuka Lake wineries — sends wine professionals to European wine conferences, vineyard exchanges, and international competitions each year. Winemakers traveling to Bordeaux, Tuscany, Rioja, and Mendoza often plan trips months in advance on group itineraries — then discover passport issues 3–4 weeks before departure when standard processing is no longer an option.",
        tip: "Wine industry professionals booking group trips to European wine regions should check their passport validity the moment the trip is confirmed. Group itineraries are fixed and unmovable — a passport delay means you miss the entire trip.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "College Study Abroad & Student Travel",
        subtitle: "Elmira College, Corning Community College, Keuka College",
        description: "The Elmira-Corning region is home to several colleges with active study abroad programs. Elmira College's distinctive Term III and international programs send students to Paris, London, Rome, and across Asia. Corning Community College and Keuka College also have growing study abroad participation. Many of these students — especially first-generation college students — have never had passports. The 4–8 week window between program acceptance and departure requires expedited processing.",
        tip: "First-time applicants at Elmira College and CCC must visit an acceptance facility in person. We guide students through the nearest facility with the earliest available appointment, so they do not miss their program orientation.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Elmira & the Twin Tiers: Industrial Heritage Meets Global Business",
      description: "Elmira is one of the smallest cities in America with a Fortune 500 company headquarters in its metro area. Corning Incorporated's global footprint means Elmira-Corning has a higher per-capita rate of international business travel than almost any small city in the United States. This creates uniquely concentrated passport demand tied to technology manufacturing and global supply chain timelines.",
    },
  },
  destinations: {
    title: "Where Elmira Travelers Go — And Why Passports Get Urgent",
    intro: "Corning's global technology manufacturing footprint means Elmira travelers need passports for semiconductor and display glass supply chain destinations spanning Asia, Europe, and beyond.",
    stats: [
      { stat: "38%", label: "of Elmira expedited requests are Corning Inc. or supplier-related business travel" },
      { stat: "1–3 Weeks", label: "average notice for Corning engineers traveling to Asian manufacturing sites" },
      { stat: "Mar–May", label: "peak when Finger Lakes wine tours to Europe, Corning Q2 business travel, and college study abroad collide" },
      { stat: "3 Days", label: "shortest turnaround for a Corning engineer departing to Taiwan for a supplier audit" },
    ],
    destinations: [
      { name: "Taiwan", context: "Corning supplier audits, display glass manufacturing, semiconductor industry partner meetings", urgency: "1–2 week notice for engineering site visits — 6-month validity required", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Corning Gorilla Glass partnerships, Samsung and LG supplier relationships, technology transfer", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates in Seoul and Tokyo", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "Corning manufacturing sites, automotive glass partners, European wine conference travel", urgency: "Trade show and industry conference dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "France & Italy", context: "Finger Lakes wine professionals visiting Bordeaux and Tuscany, Elmira College study abroad in Paris and Florence", urgency: "Wine tour group itineraries and fall semester deadlines — both fixed dates", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "Corning European headquarters connections, heritage travel, Elmira College London study programs", urgency: "Fall semester abroad deadlines and corporate quarterly meetings", icon: "ri-map-pin-2-line" },
      { name: "China", context: "Corning manufacturing partnerships, display glass facilities, telecom fiber plant visits", urgency: "Engineer site visits with 1–3 week notice and strict visa + passport validity requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Corning", route: "/cities/corning" },
      { name: "Ithaca", route: "/cities/ithaca" },
      { name: "Binghamton", route: "/cities/binghamton" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Elmira", address: "1000 N Main Street, Elmira, NY 14901", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Elmira", address: "450 S Main Street, Elmira, NY 14904", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Elmira", address: "1100 Clemens Center Parkway, Elmira, NY 14901", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Horseheads", address: "1419 County Road 64, Horseheads, NY 14845", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Corning", address: "23 S Buffalo Street, Corning, NY 14830", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Corning", address: "102 N Hamilton Street, Corning, NY 14830", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Painted Post", address: "1000 Village Square Blvd, Painted Post, NY 14870", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Watkins Glen", address: "515 N Franklin Street, Watkins Glen, NY 14891", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Elmira",
      address: "477 N Main Street, Elmira, NY 14901",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended for Elmira and Chemung County residents.",
      featured: true,
    },
    {
      name: "NYS DMV — Corning",
      address: "2 E Pulteney Street, Corning, NY 14830",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving Corning and Steuben County residents. Alternative when Elmira DMV is booked.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ELM",
      name: "Elmira Corning Regional Airport",
      distance: "5 miles from downtown Elmira",
      address: "276 Sing Sing Road, Horseheads, NY 14845",
      note: "Regional airport with Delta Connection flights to Detroit. Primary airport for Twin Tiers travelers connecting to international gateways through DTW.",
      flightUrl: "https://www.flyelmira.com/",
      flightLabel: "ELM Airport Website",
      featured: true,
    },
    {
      code: "BGM",
      name: "Greater Binghamton Airport",
      distance: "50 miles from Elmira",
      address: "2534 Airport Road, Binghamton, NY 13905",
      note: "Regional airport with flights to Philadelphia. Alternative option for Twin Tiers travelers connecting through PHL.",
      flightUrl: "https://www.flybgm.com/",
      flightLabel: "BGM Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Statistics. Required for estate and legal matters in Chemung County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Chemung County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.chemungcountyny.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Chemung County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/6jd/chemung/",
    },
  ],
};

export default elmiraConfig;